import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col, Form } from "react-bootstrap";
import messages from "../../../../assets/i18n";
import { ButtonStandard, FooterActions, ToastMessage } from '../../../../components';
import Header from "../../../../components/Header/Header";
import getMessageError from '../../../../utils/getMessageError';
import getEnvParam from "../../../../utils/getEnvParam";

function Logistic () {

	const dispatch = useDispatch();
	const lang = useSelector(state => state.language.name);
	const titlePage = messages[lang].registerTitle;
    const [show, setShow] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
	const [toastClass, setToastClass] = useState('toast-error');

	const registerError = useSelector(state => state.register.registerError);
	const registerSuccess = useSelector(state => state.register.registerSuccess);
	const cdList = useSelector(state => state.cdList);

	const [register, setRegister] = useState({
		idCd: "",
        chapa: useSelector(state => state.authentication.chapa)
	});

	useEffect(() => {
		dispatch({ type: 'GET_CDS' })
		// eslint-disable-next-line
	}, [])

	useEffect(() => {
		if(registerError.error === true) {
			let messageCode = getMessageError(registerError.data);
			setShow(true);
			setToastMessage(messages[lang].messagesCode[messageCode]);
			setToastClass('toast-error');
			dispatch({ type: "SET_REGISTER_ERROR", payload:{ error: false }});		
		}

		if(registerSuccess.success === true){
			let messageCode;
			if( registerSuccess.type === 'save' ){
				messageCode = 'register03';
			} 

			setShow(true);
			setToastMessage( messages[lang].messagesCode[messageCode]);
			setToastClass('toast-success');
			dispatch({ type: "SET_REGISTER_SUCCESS", payload:{ success: false }});

			logout();
		}
	}, [registerError, dispatch, lang, registerSuccess])

	const logout = () => {
		window.location.href = getEnvParam('REACT_APP_URL_LOGIN') + 'logout';
	}

	const dispatchRegister = () => {
        if(validateFields()) {
			dispatch({
				type: "SAVE_REGISTER",
				data: { register }
			});
		}
	}

	const handleCd = (value) => {
		setRegister({...register, idCd: value});
	}

	const ButtonGroupLeft = () => {
		return <>
			<ButtonStandard
				id="cd_list"
				text={messages[lang].cancel}
				textClass="text-3"
				className="btn btn-primary px-4 py-2 btn-light"
				icon="icon-bi-x text-3"
				onClick={logout}
			/>
		</>
	}

	const ButtonGroupRight = () => {
		return <>
			<ButtonStandard
				id="cd_list"
				text={messages[lang].save}
				textClass="text-3"
				className="btn btn-primary px-4 py-2 btn-light"
				icon="icon-bi-x text-3"
				onClick={() => dispatchRegister()}
			/>
		</>
	}

    const validateFields = () => {
        
        let message = "";
        
        if(!register.chapa || !register.chapa.length) {
            message = `${messages[lang].corporateLogin} - ${messages[lang].requiredField}`;
        
        }else if(!register.idCd || !register.idCd.length) {
            message = `Cd - ${messages[lang].requiredField}`;
        }

        if(message.trim() !== "") {
			setToastClass('toast-error');
            setToastMessage(message)
            setShow(true);

			return false;
        }else{
			return true;
		}
    }

	return (
		<div className="mainPage">
			<Header />
			<div></div>
            <ToastMessage show={show} setShow={setShow} message={toastMessage} toastClass={toastClass}/>
			<Container className="pt-3 justify-content-start">
				<Row className="justify-content-between">
					<Col className="d-flex align-items-center justify-content-start">
						<span className="text-3 font-weight-bold header-main pl-2">{titlePage}</span>
					</Col>
				</Row>
			</Container>
			<Container className="py-2 px-2 justify-content-between">
                <Form.Row className="px-4">
                <Col>
                    <Form.Group className="mt-1">
                    <Form.Label>{messages[lang].corporateLogin}:</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        placeholder={messages[lang].corporateLogin}
                        type="number"
                        value={register.chapa}
						disabled={true}
                        onChange={event => setRegister({
                            ...register,
                            chapa: event.target.value   
                        })}
                    />
                    </Form.Group>
                </Col>
                </Form.Row>
				
				<Form.Row className="px-4">
				<Col>
					<Form.Group className="mt-1">
					<Form.Label>{messages[lang].place}:</Form.Label>
					<Form.Control as="select"
						className="text-2 border-radius-full"
						onChange={event => handleCd(event.target.value)}
					>
					<option value={""}>--- {messages[lang].selectOneCd}</option>
					{
						cdList.map((value, index) => (
							<option key={index} value={value.codigo}>{`(${value.codigo}) - ${value.nome}`}</option>
						))
					}
					</Form.Control>
					</Form.Group>
				</Col>
				</Form.Row>
			</Container>

			<FooterActions ButtonGroupLeft={ButtonGroupLeft} ButtonGroupRight={ButtonGroupRight} />
		</div>
	);
}

export default Logistic;